/** Utilidades compartidas: premium fotos POS (S3) */

export function addDays(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export function getPhotosUploadStatus(access) {
  if (!access?.imagenesUpload) return { label: 'Inactivo', color: 'default' };
  if (!access?.imagenesUploadExpiresAt) return { label: 'Sin fecha', color: 'warning' };
  const diff = Math.ceil((new Date(access.imagenesUploadExpiresAt) - new Date()) / 86400000);
  if (diff > 7) return { label: `${diff}d restantes`, color: 'success' };
  if (diff > 0) return { label: `${diff}d (por vencer)`, color: 'warning' };
  if (diff > -7) return { label: 'Gracia', color: 'error' };
  return { label: 'Expirado', color: 'error' };
}

export function formatExpiryDate(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('es-BO', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function isPhotosUploadActive(access) {
  if (!access?.imagenesUpload || !access?.imagenesUploadExpiresAt) return false;
  const exp = new Date(access.imagenesUploadExpiresAt);
  if (Number.isNaN(exp.getTime())) return false;
  const end = new Date(exp);
  end.setHours(23, 59, 59, 999);
  return end >= new Date();
}

/** Acceso normalizado para UI (solo premium fotos, sin depender de la app retail). */
export function getPhotosAccessFromPolicy(data) {
  return {
    imagenesUpload: Boolean(data?.imagenesUpload),
    imagenesUploadExpiresAt: data?.imagenesUploadExpiresAt || null,
    storageLimitMb: Number(data?.storageLimitMb) > 0 ? Number(data.storageLimitMb) : 500,
  };
}
